export const getFundDisbursementGuidelinesUrl = (
    campaignType: string | undefined
): string => {
    if (campaignType?.toLowerCase() === 'transplant') {
        return 'https://s3.amazonaws.com/helphopelive/media/forms_n_flyers/HHL_Fund_Disbursement_Guidelines_-_Transplant_M6vYjbS.pdf';
    }
    return 'https://s3.amazonaws.com/helphopelive/media/forms_n_flyers/HHL_Fund_Disbursement_Guidelines_-_Injury_and_Illness_oroXKce.pdf';
};

export const getCampaignTypeFromPatient = (
    patient: { transplant_diagnosis?: string; candidacy_status?: string; listing_date?: string; living_donor?: boolean } | null | undefined
): string => {
    if (
        patient?.transplant_diagnosis ||
        patient?.candidacy_status ||
        patient?.listing_date ||
        patient?.living_donor
    ) {
        return 'transplant';
    }
    return 'injury/illness';
};
